import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { Restaurant, RestaurantBulkDishesResponse, RestaurantDetail, RestaurantDish, RestaurantDishDetail } from './data';
import { DishState } from '../menu/dishs/data';

const defaultPathApi = '/api/restaurants';
type Item = Restaurant;

export const getCurrentRestaurantIdCached = () => {
  const value = localStorage.getItem('currentRestaurant');
  const restaunrant = typeof value === 'string' ? JSON.parse(value) : undefined;

  if (restaunrant && restaunrant.id) {
    return restaunrant.id;
  } else {
    return undefined;
  }
};
const get = async () => {
  return api.get<ApiResponse<{data: Restaurant[]}>>(defaultPathApi, {
    headers: authHeader(),
  });
};
const getById = async (restaunrantId: number) => {
  return api.get<ApiResponse<RestaurantDetail>>(
    defaultPathApi + '/' + restaunrantId,
    {
      headers: authHeader(),
    },
  );
};

export type AddParams = Item;
const add = async (body?: AddParams) => {
  return api.post<ApiResponse<RestaurantDetail>>(defaultPathApi, body, {
    headers: authHeader(),
  });
};
type UpdateParams = Partial<Item>;
const update = async (id: number, body?: UpdateParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultPathApi + '/' + id,
    body,
    {
      headers: authHeader(),
    },
  );
};
type ChangeStatusParams = {
  isActive: boolean;
};
const updateStatus = async (id: number, body: ChangeStatusParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultPathApi + '/' + id + '/active',
    body,
    {
      headers: authHeader(),
    },
  );
};
type ChangePartnerStatusParams = {
  isPartner: boolean;
};
export const changePartnerStatus = async (
  id: number,
  body: ChangePartnerStatusParams,
) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultPathApi + '/change/partner-status/' + id,
    body,
    {
      headers: authHeader(),
    },
  );
};
type ChangeConfirmStatusParams = {
  confirm: boolean;
};
const changeConfirmStatus = async (
  id: number,
  body: ChangeConfirmStatusParams,
) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultPathApi + '/change/comfirm-status/' + id,
    body,
    {
      headers: authHeader(),
    },
  );
};

const getDishes = async ({
  restaurantId,
  ...params
}: {
  restaurantId: number;
  keywords?: string;
  menuIds?: number[];
  states?: DishState[];
  sortBy?: 'order';
}) => {
  return api.get<ApiResponse<RestaurantDish[]>>(defaultPathApi + '/' + restaurantId + '/dishes/filter', {
    params: params,
    headers: authHeader(),
  });
};
const getDishById = async ({ restaurantId, id }: { restaurantId: number; id: number }) => {
  return api.get<ApiResponse<RestaurantDishDetail>>(defaultPathApi + '/' + restaurantId + '/dishes/' + id, {
    headers: authHeader(),
  });
};


export type SortMenuDishesParam = {
  dishes: {
    dishId: number;
    order: number;
  }[];
};

export type ResponseMenu = {
  id: number;
  createdAt: string;
  updatedAt: string;
  restaurantId: number;
  name: string;
};

const sortMenuDishes = async ({
  restaurantId,
  menuId,
  body,
}: {
  restaurantId: number;
  menuId: number;
  body: SortMenuDishesParam;
}) => {
  return api.put<ApiResponse<ResponseMenu[]>>(
    defaultPathApi + '/' + restaurantId + '/menus/' + menuId + '/sort-dishes',
    body,
    {
      headers: authHeader(),
    },
  );
};


export type UpsertMenuParams = {
  menus: {
    id: number;
    name: string;
    order: number;
  }[];
};

const upsertMenu = async ({ restaurantId, body }: { restaurantId: number; body: UpsertMenuParams }) => {
  return api.put<ApiResponse<{ success: boolean }>>(defaultPathApi + '/' + restaurantId + '/menus', body, {
    headers: authHeader(),
  });
};

const changeRestaurantStatus = async (restaurantId: number, body: { state: string }) => {
  return api.put<ApiResponse<{ success: boolean }>>(defaultPathApi + '/' + restaurantId + '/force-change-state', body, {
    headers: authHeader(),
  });
};

const bulkCreateAndUpdateDishes = async ({ restaurantId, body }: { restaurantId: number; body: FormData }) => {
  return api.post<ApiResponse<RestaurantBulkDishesResponse>>(
    defaultPathApi + '/' + restaurantId + '/bulk-dishes',
    body,
    {
      headers: {
        'Content-Type': 'mutipart/form-data',
        ...authHeader(),
      },
    },
  );
};


export const restaurantService = {
  get,
  getById,
  add,
  upsertMenu,
  update,
  updateStatus,
  changePartnerStatus,
  changeConfirmStatus,
  getDishes,
  getDishById,
  sortMenuDishes,
  changeRestaurantStatus,
  bulkCreateAndUpdateDishes
};
